import { Application } from '../../../../../shared/models/view/Application';
import { AppFormModel } from './AppFormModel';
import { ContractInfoApi } from '../../../../../shared/models/generated/PersonContractInfoApi';
import { AppUtils } from '../../../../../shared/utils/index';

/**
 * The application model that holds the data for the whole application.
 */
export class AppApplicationModel extends Application {

	private formModel: AppFormModel;
	private step: number;
	private processId: number;
	private tarif: ContractInfoApi;

	constructor(
		register = 'mgl',
		formModel: AppFormModel = new AppFormModel()
	) {
		super(register);

		this.formModel = formModel;
	}

	set FormModel(value: AppFormModel) {
		this.formModel = value;
	}

	get FormModel(): AppFormModel {
		return this.formModel;
	}

	set Tarif(value: ContractInfoApi) {
		this.tarif = value;
	}

	get Tarif(): ContractInfoApi {
		return this.tarif;
	}

	get Step(): number {
		return this.step;
	}

	set Step(value: number) {
		this.step = value;
	}

	get ProcessId(): number {
		return this.processId;
	}

	set ProcessId(value: number) {
		this.processId = value;
	}

	private werbernummer: string;
	get Werbernummer(): string {
		return this.werbernummer;
	}

	set Werbernummer(value: string) {
		this.werbernummer = value;
	}

	public toString(): string {
		return JSON.stringify(this);
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: Record<string, any>): AppApplicationModel {
		return AppUtils.Helper.createFromMap(dataObject, AppApplicationModel, (key: string, value: any) => {
			switch (key) {
				case 'formModel':
					return AppFormModel.createFromObject(value);
				case 'tarif':
					return ContractInfoApi.createFromObject(value);
				default:
					return value;
			}
		});
	}
}
